import { createIcon } from '~/utils';

export const LogoIcon = createIcon({
  viewBox: '0 0 1828.79 479.59',
  path: [
    <g>
      <path d='M247.16,223.85h117.32v15.77c0,16.75-2.72,32.32-8.14,46.7-5.43,14.38-13.26,26.97-23.48,37.78-10.22,10.8-22.5,19.21-36.82,25.21-14.33,6.01-30.38,9.01-48.17,9.01s-34.92-3.01-49.65-9.01c-14.73-6.01-27.35-14.41-37.86-25.21-10.51-10.8-18.57-23.39-24.17-37.78-5.6-14.38-8.41-29.95-8.41-46.7s2.8-32.14,8.41-46.53c5.6-14.38,13.66-26.95,24.17-37.69,10.51-10.74,23.13-19.12,37.86-25.13,14.73-6,31.28-9.01,49.65-9.01,16.63,0,31.02,1.79,43.15,5.37,12.13,3.58,22.35,8.23,30.67,13.95,8.32,5.72,15.13,11.84,20.45,18.37,5.31,6.53,9.53,12.68,12.65,18.45l-64.46,29.11c-3.24-5.54-8-10.74-14.3-15.6-6.3-4.85-15.68-7.28-28.16-7.28-7.51,0-14.36,1.47-20.54,4.42-6.18,2.95-11.47,6.99-15.85,12.13-4.39,5.14-7.77,11.09-10.14,17.85-2.37,6.76-3.55,13.95-3.55,21.57s1.18,14.99,3.55,21.75c2.37,6.76,5.75,12.71,10.14,17.85,4.39,5.14,9.67,9.16,15.85,12.04,6.18,2.89,13.02,4.33,20.54,4.33,6,0,11.41-.43,16.2-1.3,4.79-.87,8.89-2.19,12.3-3.99,3.41-1.79,6.12-4.04,8.14-6.76,2.02-2.71,3.32-5.86,3.9-9.44h-41.24v-50.25Z' />
      <path d='M375.21,125.42h153.53v58.23h-86.47v27.73h86.47v56.32h-86.47v28.25h86.47v58.22h-153.53V125.42Z' />
      <path d='M586.45,183.65h-49.39v-58.23h165.84v58.23h-49.39v170.51h-67.06v-170.51Z' />
      <path d='M723.51,125.42h102.58c13.86,0,26.11,2.92,36.74,8.75,10.63,5.83,18.94,14.15,24.95,24.95,6.01,10.8,9.01,23.6,9.01,38.38s-2.4,26.54-7.19,35.61c-4.8,9.07-10.54,15.85-17.24,20.36-6.7,4.5-12.88,7.39-18.54,8.66l54.76,92.01h-75.21l-47.13-86.82h4.51v86.82h-67.24V125.42ZM790.75,221.94h11.09c6.12,0,11.98-1.44,17.59-4.33,5.6-2.89,8.4-8.84,8.4-17.85s-2.71-14.96-8.14-17.85c-5.43-2.89-11.21-4.33-17.33-4.33h-11.61v44.36Z' />
      <path d='M910.32,125.42h153.53v58.23h-86.47v27.73h86.47v56.32h-86.47v28.25h86.47v58.22h-153.53V125.42Z' />
      <path d='M1154.3,125.42h65.67l94.27,228.74h-71.57l-14.56-39.68h-81.62l-14.73,39.68h-71.74l94.27-228.74ZM1169.03,256.25h36.56l-18.02-50.43h-.52l-18.02,50.43Z' />
      <path d='M1426.71,291.78c8.09,0,15.91-1.27,23.48-3.81,7.57-2.54,13.43-5.08,17.59-7.62l28.59,56.84c-5.55,4.62-14.96,9.3-28.25,14.04-13.29,4.74-28.94,7.11-46.96,7.11-16.87,0-32.81-2.92-47.83-8.75-15.02-5.83-28.33-14.06-39.94-24.69-11.61-10.63-20.71-23.13-27.29-37.52-6.58-14.38-9.88-30.12-9.88-47.22s3.29-32.89,9.88-47.39c6.58-14.5,15.65-27.09,27.21-37.78,11.55-10.68,24.87-18.97,39.94-24.87s31.04-8.84,47.91-8.84c18.02,0,33.68,2.37,46.96,7.1,13.28,4.74,22.7,9.42,28.25,14.04l-28.59,56.84c-4.16-2.54-10.02-5.08-17.59-7.63-7.57-2.54-15.39-3.81-23.48-3.81-10.98,0-20.16,1.56-27.55,4.68-7.4,3.12-13.32,7.25-17.76,12.39-4.45,5.14-7.63,10.74-9.53,16.81-1.91,6.07-2.86,12.04-2.86,17.94s.95,12.07,2.86,18.2c1.91,6.12,5.08,11.76,9.53,16.9,4.45,5.14,10.37,9.27,17.76,12.39,7.39,3.12,16.58,4.68,27.55,4.68Z' />
      <path d='M1634.14,268.56h-57.71v85.6h-67.06V125.42h67.06v85.09h57.71v-85.09h66.89v228.74h-66.89v-85.6Z' />
    </g>,
    <g>
      <rect y='63.01' width='63.01' height='414.84' />
      <rect
        x='176.3'
        y='240.66'
        width='63.01'
        height='414.84'
        transform='translate(-240.27 655.89) rotate(-90)'
      />
    </g>,
    <g>
      <rect
        x='1588.13'
        y='-175.91'
        width='63.01'
        height='414.84'
        transform='translate(1651.14 -1588.13) rotate(90)'
      />
      <rect
        x='1765.77'
        y='.39'
        width='63.01'
        height='414.84'
        transform='translate(3594.56 415.62) rotate(-180)'
      />
    </g>,
  ],
});
